import { render, staticRenderFns } from "./StickerViewComponent.vue?vue&type=template&id=07d7c894&"
import script from "./StickerViewComponent.vue?vue&type=script&lang=js&"
export * from "./StickerViewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports